import React from 'react';
import { AiFillStar, AiOutlineStar } from 'react-icons/ai';
import { IoWarningOutline, IoRocketOutline } from 'react-icons/io5';

import classNames from 'styles/utils/classNames';
import { formatMarketCap, CustomColumnDef, TickerCell, TickerType } from 'screens/Calendar';

export const createSplitsColumns = (
  bookmarkedItems: Set<string>,
  handleBookmark: (symbol: string) => void,
  tickerData: TickerType[] = [],
  slug?: string,
): CustomColumnDef<any>[] => [
  {
    accessorKey: 'symbol',
    header: 'Ticker',
    cell: ({ row }) => {
      const ticker = row.original.symbol;
      const isBookmarked = bookmarkedItems.has(ticker);

      return (
        <div className="group/row relative">
          <div className="group relative ml-2">
            <button
              onClick={() => handleBookmark(ticker)}
              className={classNames(
                'absolute -left-[20px] top-1/2 z-10 -translate-y-1/2 p-1 transition-all duration-200',
                'group-hover/row:opacity-100',
                isBookmarked
                  ? 'text-yellow-400 opacity-100'
                  : 'text-gray-400 opacity-70 hover:text-yellow-400 hover:opacity-100',
              )}
              aria-label={isBookmarked ? 'Remove bookmark' : 'Add bookmark'}
            >
              {isBookmarked ? (
                <AiFillStar className="h-3 w-3" />
              ) : (
                <>
                  <AiOutlineStar className="h-3 w-3 group-hover:hidden" />
                  <AiFillStar className="hidden h-3 w-3 group-hover:block" />
                </>
              )}
            </button>
            <TickerCell ticker={ticker} tickerData={tickerData} slug={slug} />
          </div>
        </div>
      );
    },
  },
  {
    accessorKey: 'marketCap',
    header: 'Market Cap',
    csvType: 'currency-large',
    cell: ({ row }) => formatMarketCap(row.original.marketCap),
  },
  {
    accessorKey: 'date',
    header: 'Split Date',
    csvType: 'date',
  },
  {
    accessorKey: 'splitType',
    header: 'Split Type',
    cell: ({ row }) => {
      const splitType = row.original.splitType;
      return splitType || '--';
    },
  },
  {
    accessorKey: 'splitRatio',
    header: 'Split Ratio',
    cell: ({ row }) => row.original.splitRatio || '--',
  },
  {
    accessorKey: 'sentiment',
    header: 'Sentiment',
    cell: ({ row }) => {
      const sentiment = row.original.sentiment;
      let colorClass = 'text-gray-400';
      let IconComponent = null;

      if (sentiment?.includes('Bullish')) {
        colorClass = 'text-green-500';
        IconComponent = IoRocketOutline;
      } else if (sentiment?.includes('Bearish')) {
        colorClass = 'text-yellow-500';
        IconComponent = IoWarningOutline;
      }

      return (
        <div className={`flex items-center gap-2`}>
          {IconComponent && <IconComponent size={16} className={colorClass} />}
          <span>{sentiment || '--'}</span>
        </div>
      );
    },
  },
];
